import { makeObservable, observable, runInAction } from 'mobx';
import {
    IPartnerOverview,
    TenantManagementApi,
} from '@servicetitan/marketing-tenant-management-api';
import { inject, injectable } from '@servicetitan/react-ioc';
import { LoadStatus } from '../../common/enums/load-status';

@injectable()
export class PartnersStore {
    @observable partners: IPartnerOverview[] = [];
    @observable loadStatus = LoadStatus.None;

    constructor(
        @inject(TenantManagementApi) private readonly tenantManagementApi: TenantManagementApi,
    ) {
        makeObservable(this);
    }

    init = async () => {
        runInAction(() => {
            this.loadStatus = LoadStatus.Loading;
        });

        try {
            const { data: partners } = await this.tenantManagementApi.allAll();

            runInAction(() => {
                this.partners = partners;
                this.loadStatus = LoadStatus.Ok;
            });
        } catch {
            runInAction(() => {
                this.loadStatus = LoadStatus.Error;
            });
        }
    };
}
